<template>
    <v-container>
        <div
            v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')"
            class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Baujahr der Wohnung
            </h1>
            <p class="subTitle">
                Geben Sie das Baujahr des Gebäudes an oder wählen Sie die zutreffende Baujahrskategorie aus.
            </p>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="baujahr">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span class="red--text" v-html="getConflictText()"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus oder geben Sie das Baujahr manuell ein!</strong>
            </p>
            <p class="validationError" role="alert" v-if="customBaujahrError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Geben Sie hier ein valides Baujahr ein. Bitte ändern Sie Ihre Eingabe.</strong>
            </p>
            <p class="easterEgg" v-if="easterEgg">
                <v-icon style="color:#005a9f">mdi-alert</v-icon><strong>Wir sprechen nicht über 2020!</strong>
            </p>
            <div class="d-flex justify-center">
                <v-text-field v-model="customBaujahr" id="customBaujahr" reverse label="Baujahr manuell eingeben" @change="customBaujahrChanged"></v-text-field>
            </div>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group v-model="selectedItem" role="list" :aria-activedescendant="selectedItem" color="transparent" tabindex="0" active-class="list-selected" @change="onSelectBaujahr">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                v-on:dblclick="selectAndNext(item.id)"
                                tabindex="-1"
                                :id="item.id"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('baujahr.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText(item.errorTypes, item.error, item.id)" v-html="getErrorText(item.errorTypes, item.error, item.id)"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-text="$t('baujahr.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div >
            <v-card class="d-flex justify-center" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Modernisierung</h3><br/>
                            <p>Zu modernisiertem Wohnraum ist zu bemerken: Grundsätzlich ist die Wohnung in die Baualtersklasse einzuordnen, in der das Gebäude erstellt wurde. Ist eine Kernsanierung erfolgt oder durch An- oder Umbau neuer Wohnraum geschaffen worden (zum Beispiel Dachgeschossausbau), ist die Wohnung in die Baualtersklasse einzuordnen, in der die Baumaßnahmen abgeschlossen wurden.</p>
                            <p>Eine von der*dem Mieter*in auf eigene Kosten eingebrachte Ausstattung der Wohnung oder durchgeführte Instandsetzung/Modernisierung darf nicht berücksichtigt werden.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { mapActions, createNamespacedHelpers } from 'vuex';
    import { EventBus } from '../eventbus';

    const { mapMutations, mapState } = createNamespacedHelpers('error')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a baujahr ERROR
        computed: { ...mapState(['baujahr']),
                    ...mapGetters(['hasPermission'])
                    },
        methods: { ...mapActions('berechnung', ['SELECT_BAUJAHR']),
                    ...mapMutations(['SET_BAUJAHR_ERROR']),
                    ...mapActions('error', ['CHECK_GEBAEUDETYP_ERROR']),
                    ...mapActions('error', ['CHECK_HAUSTYP_ERROR']),
                    ...mapActions('error', ['CHECK_SANITAERBEREICH_ERROR']),
                    ...mapActions('error', ['CHECK_MODERNISIERTERBODEN_ERROR']),
                    ...mapActions('error', ['CHECK_TERRASSEBALKON_ERROR']),
                    ...mapActions('error', ['CHECK_MODERNISIERTEFENSTER_ERROR']),
                    ...mapActions('error', ['CHECK_ABWEICHUNGEN_ERROR']),
                    ...mapActions('error', ['CHECK_FUSSBODEN_ERROR']),
                    ...mapActions('error', ['CHECK_FUSSBODENHEIZUNG_ERROR']),
                    }
    })
    export default class Baujahr extends Vue {

        get error(){
            return this.hasError(this.selectedData.error)
        }

        get selectedData(){
            return this.items.filter(item => item.id === this.selectedItem)[0]
        }

        data() {
            return {
                index: 3,
                selectedItem: this.$store.state.berechnung.selectedBaujahr,
                customBaujahr: '',
                customBaujahrError: false,
                items: [
                    { id: 0,
                      error: {
                            selectedGebaeudetyp: function(el){return el == 0},
                            selectedHaustyp: function(el){return el == 3 || el == 4},
                            abweichungen: function(el){
                                            return el.rueckgebaeude != null && el.rueckgebaeude != 0
                                                || el.waermedaemmung !=null && el.waermedaemmung != 0},
                      },
                      errorTypes: [
                            "Gebaeudetyp",
                            "Haustyp",
                            "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 1,
                      error: {
                            selectedGebaeudetyp:  function(el){return el == 0},
                            selectedHaustyp: function(el){return el == 3 || el == 4},
                            abweichungen: function(el){
                                            return el.rueckgebaeude != null && el.rueckgebaeude != 0
                                                || el.waermedaemmung !=null && el.waermedaemmung != 0},
                      },
                      errorTypes: [
                            "Gebaeudetyp",
                            "Haustyp",
                            "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 2,
                      error: {
                            selectedGebaeudetyp: function(el){return el == 0},
                            selectedHaustyp: function(el){return el == 3 || el == 4},
                            abweichungen: function(el){
                                            return el.rueckgebaeude != null && el.rueckgebaeude != 0
                                                || el.waermedaemmung !=null && el.waermedaemmung != 0},
                      },
                      errorTypes: [
                        "Gebaeudetyp",
                        "Haustyp",
                        "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 3,
                      error: {
                            selectedHaustyp: function(el){return el < 3 && el != null},
                            selectedModernisierteFenster: function(el){return el == 0},
                            abweichungen: function (el){return el.fassadeA !=null && el.fassadeA != 0
                                                            || el.fassadeB !=null && el.fassadeB != 0
                            }
                      },
                      errorTypes: [
                        "Haustyp",
                        "ModernisierteFenster",
                        "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 4,
                      error: {
                            selectedHaustyp: function(el){return el < 3 && el != null},
                            selectedModernisierteFenster: function(el){return el == 0},
                            abweichungen: function (el){return el.fassadeA !=null && el.fassadeA != 0
                                                            || el.fassadeB !=null && el.fassadeB != 0
                            }
                      },
                      errorTypes: [
                        "Haustyp",
                        "ModernisierteFenster",
                        "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 5,
                      error: {
                        selectedHaustyp: function(el){return el < 4 && el != null},
                        selectedModernisierteFenster: function(el){return el == 0},
                        abweichungen: function (el){return el.fassadeA !=null && el.fassadeA != 0
                                                        || el.fassadeB !=null && el.fassadeB != 0
                        }
                      },
                      errorTypes: [
                        "Haustyp",
                        "ModernisierteFenster",
                        "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 6,
                      error: {
                        selectedHaustyp: function(el){return el < 4 && el != null},
                        selectedModernisierteFenster: function(el){return el == 0},
                        abweichungen: function (el){return el.fassadeA !=null && el.fassadeA != 0
                                                        || el.fassadeB !=null && el.fassadeB != 0
                        }
                      },
                      errorTypes: [
                        "Haustyp",
                        "ModernisierteFenster",
                        "Abweichungen"
                      ],
                    },
                    { divider: true},
                    { id: 7,
                      error: {
                        selectedGebaeudetyp: function(el){return el == 0},
                        selectedHaustyp: function(el){return el < 4 && el != null},
                        //TODO nochmals prüfen, wenn Sanitärbereich Auswahlmöglichkeiten klar
                        selectedSanitaerbereich: function(el){return el.includes(4)},
                        selectedTerrasseBalkon: function(el){return el == 0},
                        selectedModernisierteFenster: function(el){return el == 0},
                        abweichungen: function(el){ return el.waermedaemmung !=null && el.waermedaemmung != 0
                                                    || el.fassadeA !=null && el.fassadeA != 0
                                                    || el.fassadeB !=null && el.fassadeB != 0},
                        selectedFussbodenheizung: function (el) { return el == 0}
                      },
                      errorTypes: [
                        "Gebaeudetyp",
                        "Haustyp",
                        "Sanitaerbereich",
                        "TerrasseBalkon",
                        "ModernisierteFenster",
                        "Abweichungen",
                        "Fussbodenheizung"
                      ],
                    },
                    { divider: true},
                    { id: 8,
                      error: {
                        selectedGebaeudetyp: function(el){return el == 0},
                        selectedHaustyp: function(el){return el < 4 && el != null},
                        //TODO nochmals prüfen, wenn Sanitärbereich Auswahlmöglichkeiten klar
                        selectedSanitaerbereich: function(el){return el.includes(4)},
                        selectedTerrasseBalkon: function(el){return el == 0},
                        selectedModernisierteFenster: function(el){return el == 0},
                        abweichungen: function(el){ return el.waermedaemmung !=null && el.waermedaemmung != 0
                                                    || el.fassadeA !=null && el.fassadeA != 0
                                                    || el.fassadeB !=null && el.fassadeB != 0},
                        selectedFussbodenheizung: function (el) { return el == 0}
                      },
                      errorTypes: [
                        "Gebaeudetyp",
                        "Haustyp",
                        "Sanitaerbereich",
                        "TerrasseBalkon",
                        "ModernisierteFenster",
                        "Abweichungen",
                        "Fussbodenheizung"
                      ],
                    },
                    { divider: true},
                    { id: 9,
                      error: {
                        selectedGebaeudetyp: function(el){return el == 0},
                        selectedHaustyp: function(el){return el < 4 && el != null},
                        //TODO nochmals prüfen, wenn Sanitärbereich Auswahlmöglichkeiten klar
                        selectedSanitaerbereich: function(el){return el.includes(4)},
                        selectedTerrasseBalkon: function(el){return el == 0},
                        selectedModernisierterBoden: function(el){return el == 0},
                        abweichungen: function(el){ return el.waermedaemmung !=null && el.waermedaemmung != 0
                                                    || el.fassadeA !=null && el.fassadeA != 0
                                                    || el.fassadeB !=null && el.fassadeB != 0},
                        selectedModernisierteFenster: function(el){return el == 0},
                        selectedFussbodenheizung: function (el) { return el == 0}
                      },
                      errorTypes: [
                        "Gebaeudetyp",
                        "Haustyp",
                        "Sanitaerbereich",
                        "TerrasseBalkon",
                        "ModernisierterBoden",
                        "Abweichungen",
                        "ModernisierteFenster",
                        "Fussbodenheizung"
                      ],
                    },
                    { divider: true},
                    { id: 10,
                      error: {
                        selectedGebaeudetyp: function(el){return el == 0},
                        selectedHaustyp: function(el){return el < 4 && el != null},
                        //TODO nochmals prüfen, wenn Sanitärbereich Auswahlmöglichkeiten klar
                        selectedSanitaerbereich: function(el){return el.includes(4)},
                        selectedTerrasseBalkon: function(el){return el == 0},
                        selectedModernisierterBoden: function(el){return el == 0},
                        abweichungen: function(el){ return el.waermedaemmung !=null && el.waermedaemmung != 0
                                                    || el.fassadeA !=null && el.fassadeA != 0
                                                    || el.fassadeB !=null && el.fassadeB != 0},
                        selectedModernisierteFenster: function(el){return el == 0},
                        selectedFussbodenheizung: function (el) { return el == 0}
                      },
                      errorTypes: [
                        "Gebaeudetyp",
                        "Haustyp",
                        "Sanitaerbereich",
                        "TerrasseBalkon",
                        "ModernisierterBoden",
                        "Abweichungen",
                        "ModernisierteFenster",
                        "Fussbodenheizung"
                      ],
                    },
                ],
                easterEgg: false,
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(errorTypes, error, id){
            return this.getErrorTexts(errorTypes, error, id).join('<br/>')
        }

        /*
         * implementation differing to other components (only without join at the end -> done in variations in getErrorText() and getConflictText())
         * because multiple cross-component errors are possible for one selectedItem here
         */
        getErrorTexts(errorTypes, error, id){
            /*
             * select those errorTypes (= different components), whose selected value
             * in the store is matched by the function at the same index in error (of the item)
             */
            let errorType = errorTypes.filter((_, i) => error[Object.keys(error)[i]](this.$store.state.berechnung[Object.keys(error)[i]]));
            //Abweichungen Error Text hardcoded
            let errorString = []
            if(errorType.includes("Abweichungen")) {
                let rueckgebaeudeSet = { rueckgebaeude: 0.1 }
                let waermedaemmungSet = { waermedaemmung: 0.1 }
                //works because every option with Abweichungen constraint has the putz constraint as well
                if(this.$store.state.berechnung.abweichungen.rueckgebaeude != 0 && error.abweichungen(rueckgebaeudeSet) ){
                    errorString.push(this.$t('baujahr.rueckgebaeudeError', {currentChoice: this.$t('baujahr.' + id)}))
                }
                if(this.$store.state.berechnung.abweichungen.waermedaemmung != 0 && error.abweichungen(waermedaemmungSet)){
                    errorString.push(this.$t('baujahr.waermedaemmungError', {currentChoice: this.$t('baujahr.' + id)}))
                }
                if(this.$store.state.berechnung.abweichungen.fassadeA != 0 || this.$store.state.berechnung.abweichungen.fassadeB != 0){
                    errorString.push(this.$t('baujahr.fassadeAError', {currentChoice: this.$t('baujahr.' + id)}))
                }
            }
            return errorType.filter(el => el != "Abweichungen")
                            .map(el => {
                //additional steps before translation where related error can be multiple choice
                let selectedElement = this.$store.state.berechnung['selected' + el]
                let chosen
                if(Array.isArray(selectedElement)){
                    chosen = selectedElement.filter(elem => error['selected' + el]([elem]))
                        .map(item => this.$t(el.charAt(0).toLowerCase() + el.substring(1) + '.' + item)
                        ).join(" & ")
                }else{
                    chosen = this.$t(el.charAt(0).toLowerCase() + el.substring(1) + '.' + selectedElement)
                }
                return this.$t('warning.select',
                    { step: this.$t(el),
                      choice: chosen,
                      currentStep: "des Baujahres ",
                      currentChoice: this.$t('baujahr.' + id)
                    })}).concat(errorString);
        }

        //when conflict is present its text is depending on the item in the store, not the current selection
        getConflictText(){
            let conflictItem = this.items.filter(item => item.id === this.$store.state.berechnung.selectedBaujahr)[0]
            return this.getErrorTexts(conflictItem.errorTypes, conflictItem.error, conflictItem.id).join('<br/><div><i class="mdi mdi-alert v-icon notranslate theme--light" style="color:#c50517"></i><strong class="red--text">Konflikt!</strong></div>')
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const baujahrInput = document.querySelector('#customBaujahr')
            this.$root.$on('unfocusList', () => {
                baujahrInput.focus()
            })
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            if ((this.selectedItem == undefined || this.selectedItem == null) && this.customBaujahr !== '') {
                this.selectedItem == this.computeSelection(this.customBaujahr);
            }
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedData.id)
            this.SELECT_BAUJAHR({ selectedBaujahr: this.selectedItem, selectedBaujahrError: this.selectedData.error })
            //check all possible related errors
            this.CHECK_GEBAEUDETYP_ERROR()
            this.CHECK_HAUSTYP_ERROR()
            this.CHECK_SANITAERBEREICH_ERROR()
            this.CHECK_MODERNISIERTERBODEN_ERROR()
            this.CHECK_TERRASSEBALKON_ERROR()
            this.CHECK_MODERNISIERTEFENSTER_ERROR()
            this.CHECK_ABWEICHUNGEN_ERROR()
            this.CHECK_FUSSBODEN_ERROR()
            this.CHECK_FUSSBODENHEIZUNG_ERROR()
            if(this.error){
                console.log('found baujahr error')
                this.SET_BAUJAHR_ERROR(true)
                let alert = document.querySelector('.errors')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            }else{
                this.SET_BAUJAHR_ERROR(false)
                this.$router.push('wohnlage')
            }
        }

        back() {
            this.$router.push('wohnflaeche')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }

        computeSelection(baujahr) {
            if(isNaN(baujahr) || baujahr > 2023 || baujahr < 0 || (baujahr != parseInt(baujahr))) {
                this.customBaujahrError = true;
                return null;
            }
            if(this.isEasterEgg(baujahr)) {
                this.easterEgg = true;
            }
            switch (true) {
                case baujahr <= 1918:
                    return 0;
                case baujahr <= 1929:
                    return 1;
                case baujahr <= 1948:
                    return 2;
                case baujahr <= 1966:
                    return 3;
                case baujahr <= 1977:
                    return 4;
                case baujahr <= 1988:
                    return 5;
                case baujahr <= 1998:
                    return 6;
                case baujahr <= 2008:
                    return 7;
                case baujahr <= 2018:
                    return 8;
                case baujahr <= 2021:
                    return 9;
                case baujahr <= 2023:
                    return 10;
            }
            this.customBaujahrError = true;
            return null;
        }

        customBaujahrChanged() {
            this.customBaujahrError = false;
            this.easterEgg = false;
            if (this.customBaujahr === '') {
                return;
            }
            var selection = this.computeSelection(this.customBaujahr);
            this.selectedItem = selection;
        }

        onSelectBaujahr() {
            this.customBaujahr = '';
            this.customBaujahrError = false;
        }

        /*isCustomBaujahrInvalid() {
            //var baujahr = this.customBaujahr; ??
        }*/

        isEasterEgg(baujahr) {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!

            today = dd + '.' + mm
            return today === '01.04' && baujahr == '2020';
        }
    }
</script>
